<template>
    <table class="venue-features-profile" v-if="features">
        <tbody>
        <template v-for="(feature) in boolFeaturesFormatted">
            <tr v-if="feature">
                <td class="venue-features-list-name d-flex align-items-center">
                    <icon-component :icon="feature.icon"></icon-component>
                    <span class="grey-text text-uppercase">{{ feature.name }}</span>
                </td>
                <td>
                    <span class="venue-features-list-text">
                        {{ feature.value }}
                    </span>
                </td>
            </tr>
        </template>

        </tbody>
    </table>
</template>

<script>

import {fa_globe_americas, fa_home, fa_spa, fa_utensils} from "@/core/constants/icons";
import IconComponent from "@/components/global/IconComponent.vue";

const boolFeaturesRaw = [
    {name: 'amenities', icon: fa_home()},
    {name: 'foodAndDrink', icon: fa_utensils()},
    {name: 'wellness', icon: fa_spa()},
    {name: 'locationAndParking', icon: fa_globe_americas()},
];

function translateFeatureName(name) {
    return _.get(this, 'translate.account.featuresVenue.' + name);
}

function getBoolFeaturesRow(feature) {
    let features = _.get(this, 'features.' + feature.name, {})
    features = Object.entries(features)
        .filter(value => !!value[1])
        .map(value => _.get(this, 'translate.account.featuresVenue.' + value[0]))
        .join(', ')
    return features;
}

export default {
    components: {IconComponent},
    computed: {
        ...mapState(['translate']),
        boolFeaturesFormatted() {
            return boolFeaturesRaw
                .map(feature => {
                    const value = this.getBoolFeaturesRow(feature);
                    if (!value) {
                        return null;
                    }

                    return {
                        name: this.translateFeatureName(feature.name),
                        value,
                        icon: feature.icon,
                    };
                })
                .filter(Boolean);
        },
    },
    methods: {
        translateFeatureName,
        getBoolFeaturesRow,
    },
    props: ['features'],
}
</script>
